// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForecastSection_section__-CnOA {
  background: rgba(60, 29, 105, 0.15);
  border-radius: 20px;
  padding: 10px 0;
  margin-bottom: 24px;
  box-shadow: 0 2px 24px 0 rgba(41, 13, 94, 0.08);
}

.ForecastSection_titleBlock__LSLhk {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}

.ForecastSection_forecastTitle__g9HjY {
  font-size: 19px;
  font-weight: 600;
  line-height: 1.3;
  color: #fff;
  padding: 10px 0 10px 16px;
  margin: 0;
}

.ForecastSection_forecastText__7V9yH {
  font-size: 15px;
  color: #f0f0f0;
  line-height: 1.65;
  background: rgba(255, 255, 255, 0.05);
  padding: 16px;
  border-radius: 14px;
  backdrop-filter: blur(4px);
  white-space: pre-line;
  text-align: left;
  margin: 22px 0;
}

.ForecastSection_share__4IcMN {
  display: flex;
  cursor: pointer;
  border-radius: 15px;
  padding: 5px;
  background: linear-gradient(93deg, #795cff 0%, #ad7cff 100%);
}

.ForecastSection_toggleButtonWrapper__PZDhM {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.ForecastSection_cta__G0DTz {
  display: flex;
  justify-content: center;
}

.ForecastSection_toast__-sLIH {
  width: 70%;
  max-width: 450px;
  position: fixed;
  left: 50%;
  bottom: 120px;
  transform: translateX(-50%);
  background: linear-gradient(93deg, #795cff 0%, #ad7cff 100%);
  color: #fff;
  padding: 14px 20px;
  border-radius: 16px;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 500;
  z-index: 9999;
  box-shadow: 0 2px 20px 0 rgba(60, 29, 105, 0.15);
  animation: ForecastSection_fadeInToast__217ox 0.3s;
}
@keyframes ForecastSection_fadeInToast__217ox {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.ForecastSection_copyModal__V4za0 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ForecastSection_modalFadeIn__Tanza 0.15s;
  background: rgba(0, 0, 0, 0.446);
}

@keyframes ForecastSection_modalFadeIn__Tanza {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.ForecastSection_copyModalContent__urJtA {
  background: rgba(0, 0, 0, 0.446);
  border-radius: 2rem;
  padding: 2.2rem 1.5rem 1.5rem 1.5rem;
  box-shadow: 0 10px 28px 0 rgba(0, 0, 0, 0.22);
  max-width: 80vw;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.6rem;
}

.ForecastSection_copyModalContent__urJtA textarea {
  background: transparent;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  border-radius: 13px;
  border: solid 1px #ffffff71;
  color: #fff;
  padding: 1rem;
  resize: none;
  margin-bottom: 0.5rem;
  width: 70%;
  outline: none;
}

.ForecastSection_copyHint__2OFD2 {
  font-size: 11px;
  color: #cccccc;
  margin-top: 0.9rem;
  text-align: center;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Forecast/sections/ForecastSection.module.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,4DAA4D;EAC5D,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,kDAA2B;AAC7B;AACA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oCAAoC;EACpC,6CAA6C;EAC7C,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB;wEACsE;EACtE,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".section {\n  background: rgba(60, 29, 105, 0.15);\n  border-radius: 20px;\n  padding: 10px 0;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 24px 0 rgba(41, 13, 94, 0.08);\n}\n\n.titleBlock {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 auto;\n}\n\n.forecastTitle {\n  font-size: 19px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #fff;\n  padding: 10px 0 10px 16px;\n  margin: 0;\n}\n\n.forecastText {\n  font-size: 15px;\n  color: #f0f0f0;\n  line-height: 1.65;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 16px;\n  border-radius: 14px;\n  backdrop-filter: blur(4px);\n  white-space: pre-line;\n  text-align: left;\n  margin: 22px 0;\n}\n\n.share {\n  display: flex;\n  cursor: pointer;\n  border-radius: 15px;\n  padding: 5px;\n  background: linear-gradient(93deg, #795cff 0%, #ad7cff 100%);\n}\n\n.toggleButtonWrapper {\n  display: flex;\n  justify-content: center;\n  margin-top: 8px;\n}\n\n.cta {\n  display: flex;\n  justify-content: center;\n}\n\n.toast {\n  width: 70%;\n  max-width: 450px;\n  position: fixed;\n  left: 50%;\n  bottom: 120px;\n  transform: translateX(-50%);\n  background: linear-gradient(93deg, #795cff 0%, #ad7cff 100%);\n  color: #fff;\n  padding: 14px 20px;\n  border-radius: 16px;\n  font-size: 12px;\n  line-height: 1.5;\n  font-weight: 500;\n  z-index: 9999;\n  box-shadow: 0 2px 20px 0 rgba(60, 29, 105, 0.15);\n  animation: fadeInToast 0.3s;\n}\n@keyframes fadeInToast {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n.copyModal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: modalFadeIn 0.15s;\n  background: rgba(0, 0, 0, 0.446);\n}\n\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.copyModalContent {\n  background: rgba(0, 0, 0, 0.446);\n  border-radius: 2rem;\n  padding: 2.2rem 1.5rem 1.5rem 1.5rem;\n  box-shadow: 0 10px 28px 0 rgba(0, 0, 0, 0.22);\n  max-width: 80vw;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.6rem;\n}\n\n.copyModalContent textarea {\n  background: transparent;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  border-radius: 13px;\n  border: solid 1px #ffffff71;\n  color: #fff;\n  padding: 1rem;\n  resize: none;\n  margin-bottom: 0.5rem;\n  width: 70%;\n  outline: none;\n}\n\n.copyHint {\n  font-size: 11px;\n  color: #cccccc;\n  margin-top: 0.9rem;\n  text-align: center;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `ForecastSection_section__-CnOA`,
	"titleBlock": `ForecastSection_titleBlock__LSLhk`,
	"forecastTitle": `ForecastSection_forecastTitle__g9HjY`,
	"forecastText": `ForecastSection_forecastText__7V9yH`,
	"share": `ForecastSection_share__4IcMN`,
	"toggleButtonWrapper": `ForecastSection_toggleButtonWrapper__PZDhM`,
	"cta": `ForecastSection_cta__G0DTz`,
	"toast": `ForecastSection_toast__-sLIH`,
	"fadeInToast": `ForecastSection_fadeInToast__217ox`,
	"copyModal": `ForecastSection_copyModal__V4za0`,
	"modalFadeIn": `ForecastSection_modalFadeIn__Tanza`,
	"copyModalContent": `ForecastSection_copyModalContent__urJtA`,
	"copyHint": `ForecastSection_copyHint__2OFD2`
};
export default ___CSS_LOADER_EXPORT___;
